/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  PostTeamsTeamidInviteMutationRequest,
  PostTeamsTeamidInviteMutationResponse,
  PostTeamsTeamidInvitePathParams,
  PostTeamsTeamidInvite400,
  PostTeamsTeamidInvite401,
  PostTeamsTeamidInvite403,
  PostTeamsTeamidInvite500,
} from "../types/PostTeamsTeamidInvite.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const postTeamsTeamidInviteMutationKey = () =>
  [{ url: "/teams/:teamId/invite" }] as const;

export type PostTeamsTeamidInviteMutationKey = ReturnType<
  typeof postTeamsTeamidInviteMutationKey
>;

/**
 * @description Отправляет приглашение пользователю присоединиться к команде.
 * Только капитан команды может приглашать участников.
 * Пользователь получит уведомление о приглашении.
 * @summary Пригласить пользователя в команду
 * {@link /teams/:teamId/invite}
 */
export async function postTeamsTeamidInvite(
  teamId: PostTeamsTeamidInvitePathParams["teamId"],
  data?: PostTeamsTeamidInviteMutationRequest,
  config: Partial<RequestConfig<PostTeamsTeamidInviteMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostTeamsTeamidInviteMutationResponse,
    ResponseErrorConfig<
      | PostTeamsTeamidInvite400
      | PostTeamsTeamidInvite401
      | PostTeamsTeamidInvite403
      | PostTeamsTeamidInvite500
    >,
    PostTeamsTeamidInviteMutationRequest
  >({
    method: "POST",
    url: `/teams/${teamId}/invite`,
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}

export function postTeamsTeamidInviteMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostTeamsTeamidInviteMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = postTeamsTeamidInviteMutationKey();
  return mutationOptions<
    ResponseConfig<PostTeamsTeamidInviteMutationResponse>,
    ResponseErrorConfig<
      | PostTeamsTeamidInvite400
      | PostTeamsTeamidInvite401
      | PostTeamsTeamidInvite403
      | PostTeamsTeamidInvite500
    >,
    {
      teamId: PostTeamsTeamidInvitePathParams["teamId"];
      data?: PostTeamsTeamidInviteMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ teamId, data }) => {
      return postTeamsTeamidInvite(teamId, data, config);
    },
  });
}

/**
 * @description Отправляет приглашение пользователю присоединиться к команде.
 * Только капитан команды может приглашать участников.
 * Пользователь получит уведомление о приглашении.
 * @summary Пригласить пользователя в команду
 * {@link /teams/:teamId/invite}
 */
export function usePostTeamsTeamidInvite<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<PostTeamsTeamidInviteMutationResponse>,
      ResponseErrorConfig<
        | PostTeamsTeamidInvite400
        | PostTeamsTeamidInvite401
        | PostTeamsTeamidInvite403
        | PostTeamsTeamidInvite500
      >,
      {
        teamId: PostTeamsTeamidInvitePathParams["teamId"];
        data?: PostTeamsTeamidInviteMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostTeamsTeamidInviteMutationRequest>> & {
      client?: Client;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postTeamsTeamidInviteMutationKey();

  const baseOptions = postTeamsTeamidInviteMutationOptions(
    config,
  ) as UseMutationOptions<
    ResponseConfig<PostTeamsTeamidInviteMutationResponse>,
    ResponseErrorConfig<
      | PostTeamsTeamidInvite400
      | PostTeamsTeamidInvite401
      | PostTeamsTeamidInvite403
      | PostTeamsTeamidInvite500
    >,
    {
      teamId: PostTeamsTeamidInvitePathParams["teamId"];
      data?: PostTeamsTeamidInviteMutationRequest;
    },
    TContext
  >;

  return useMutation<
    ResponseConfig<PostTeamsTeamidInviteMutationResponse>,
    ResponseErrorConfig<
      | PostTeamsTeamidInvite400
      | PostTeamsTeamidInvite401
      | PostTeamsTeamidInvite403
      | PostTeamsTeamidInvite500
    >,
    {
      teamId: PostTeamsTeamidInvitePathParams["teamId"];
      data?: PostTeamsTeamidInviteMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    ResponseConfig<PostTeamsTeamidInviteMutationResponse>,
    ResponseErrorConfig<
      | PostTeamsTeamidInvite400
      | PostTeamsTeamidInvite401
      | PostTeamsTeamidInvite403
      | PostTeamsTeamidInvite500
    >,
    {
      teamId: PostTeamsTeamidInvitePathParams["teamId"];
      data?: PostTeamsTeamidInviteMutationRequest;
    },
    TContext
  >;
}
